import { useResolveVoucherDevicePrice } from '~/composable/voucher/useResolveVoucherDevicePrice'

const calculateInstallmentAmountFromPrice = (lineItemPrice, months) => {
  if (!lineItemPrice || !months || months === 0) {
    return 0
  }
  return Math.ceil((lineItemPrice / months) * 100) / 100
}

const getSubscriptionPriceFromGroup = (cartItemGroup, isSubscription) => {
  const subscriptionCartItem = cartItemGroup?.cartItems?.find(item =>
    isSubscription(item.cartProduct?.productTypeKey)
  )
  return subscriptionCartItem?.cartProduct?.selectedPrice?.lineItemPrice || 0
}

const getDeviceLineItemPrice = (cartItem, resolveDeviceLineItemPrice) => {
  if (resolveDeviceLineItemPrice) {
    return resolveDeviceLineItemPrice(cartItem)
  }
  return cartItem?.cartProduct?.selectedPrice?.lineItemPrice || 0
}

const resolveInstallmentAmount = (deviceLineItemPrice, installmentMonths, fallbackInstallmentAmount) => {
  const recalculatedInstallmentAmount = calculateInstallmentAmountFromPrice(deviceLineItemPrice, installmentMonths)
  if (recalculatedInstallmentAmount > 0) {
    return recalculatedInstallmentAmount
  }
  return fallbackInstallmentAmount
}

const getInstallmentData = (cartItem, resolveDeviceLineItemPrice) => {
  const selectedInstallment = cartItem?.cartProduct?.selectedPrice?.selectedInstallment
  const deviceLineItemPrice = getDeviceLineItemPrice(cartItem, resolveDeviceLineItemPrice)
  const installmentMonths = selectedInstallment?.months || 0
  const fallbackInstallmentAmount = selectedInstallment?.amount || 0
  const installmentAmount = resolveInstallmentAmount(deviceLineItemPrice, installmentMonths, fallbackInstallmentAmount)

  return {
    selectedInstallment,
    deviceLineItemPrice,
    installmentMonths,
    installmentAmount
  }
}

const calculateTotalFromCartValues = (subscriptionPrice, installmentAmount) => {
  if (subscriptionPrice > 0 && installmentAmount > 0) {
    return subscriptionPrice + installmentAmount
  }
  return null
}

const calculateTotalFromInstallmentData = (selectedInstallment, installmentAmount) => {
  if (selectedInstallment?.monthlyAmountWithSubscription && installmentAmount > 0) {
    const calculatedSubscription = selectedInstallment.monthlyAmountWithSubscription - installmentAmount
    if (calculatedSubscription > 0) {
      return calculatedSubscription + installmentAmount
    }
  }
  return null
}

const useBackendValueAsFallback = (selectedInstallment) => {
  if (selectedInstallment?.monthlyAmountWithSubscription) {
    return selectedInstallment.monthlyAmountWithSubscription
  }
  return null
}

export default function useMonthlyPrice () {
  const { resolveFromCartItem } = useResolveVoucherDevicePrice()

  const getTotalMonthlyPrice = (cartItem, cartItemGroup, isSubscription) => {
    const subscriptionPrice = getSubscriptionPriceFromGroup(cartItemGroup, isSubscription)
    const { selectedInstallment, installmentAmount } = getInstallmentData(cartItem, resolveFromCartItem)

    const totalFromCart = calculateTotalFromCartValues(subscriptionPrice, installmentAmount)
    if (totalFromCart !== null) {
      return totalFromCart
    }

    const totalFromInstallment = calculateTotalFromInstallmentData(selectedInstallment, installmentAmount)
    if (totalFromInstallment !== null) {
      return totalFromInstallment
    }

    const backendValue = useBackendValueAsFallback(selectedInstallment)
    if (backendValue !== null) {
      return backendValue
    }

    return 0
  }

  return {
    getTotalMonthlyPrice
  }
}
